//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ShareLinks',

  emits: ['isInWishlist'],

  data() {
    return {
      isShowLinks: false,

      socialLinkList: [
        {name: 'vk', link: 'https://vk.com/share.php?url='},
        {name: 'ok', link: 'https://connect.ok.ru/offer?url='},
        // {name: 'twitter', link: 'https://twitter.com/intent/tweet?url='},
        {name: 'whatsapp', link: 'https://api.whatsapp.com/send/?text='},
        {name: 'telegram', link: 'https://telegram.me/share/url?url='},
      ]
    }
  },

  props: {
    wasAddedInWishList: {
      type: Boolean,
      default: false,
    }
  },

  methods: {
    isInWishlist() {
      this.$emit('isInWishlist');
    },

    openShare(link) {
      window.open(`${link}${window.location.href}`)
    },

    showShareLinks() {
      this.isShowLinks = !this.isShowLinks;
    },
    async copyLink() {
      try {
        await this.$copyText(window.location.href);
        this.$toast.success('Ссылка скопирована');
      } catch (e) {
        this.$toast.success('Ошибка копирования');
      }
    },
  },
}
